import { createSlice } from '@reduxjs/toolkit';

// Slice for data of areaGrave
export const dataAreaGraveSlice = createSlice({
  name: 'dataAreaGrave',
  initialState: { data: [] },
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    },
  },
})

// שדות לטבלת קבר
export const columnsTableAreaGraveSlice = createSlice({
  name: 'columnsAreaGrave',
  initialState: {
    data: [ 
      { id: 0, field: 'id',             headerName: 'ID',           input: 'text', width: 70,                  show: false  },
      { id: 1, field: 'areaGraveNameHe',headerName: 'קבר',          input: 'text', width: 120,                  show: true },
      { id: 4, field: 'lineNameHe',     headerName: 'שורה',         input: 'text', width: 120,                  show: true },
      { id: 5, field: 'plotNameHe',     headerName: 'חלקה',         input: 'text', width: 200,                 show: true },
      { id: 5, field: 'blockNameHe',    headerName: 'גוש',          input: 'text', width: 200,                 show: true },
      { id: 5, field: 'cemeteryNameHe', headerName: 'בית עלמין',    input: 'text', width: 200,                 show: true },
      // { id: 3, field: 'gravesCount',   headerName: 'מס׳ קומות',    input: 'text', width: 140,                 show: true },
      { id: 5, field: 'availableSum',      headerName: 'פנויים',       input: 'text', width: 140,  isActive: true, show: true},
      { id: 5, field: 'purchasedSum',      headerName: 'רכישות',       input: 'text', width: 140,  isActive: true, show: true},
      { id: 5, field: 'buriedSum',         headerName: 'קבורים',       input: 'text', width: 140,  isActive: true, show: true},
      { id: 5, field: 'savedSum',          headerName: 'שמורים',       input: 'text', width: 140,  isActive: true, show: true},
      { id: 5, field: 'graveSum',       headerName: 'סה״כ',         input: 'text', width: 140, isActive: true, show: true},
      { id: 7, field: 'documentsList',  headerName: 'רשימת מסמכים', input: 'text', width: 170,                 show: false },
      { id: 8, field: 'isActive',       headerName: 'פעיל',         input: 'text', width: 80,                  show: false },
      { id: 9, field: 'createdDate',    headerName: 'תאריך יצירה',  input: 'date', width: 130,                 show: false },
      { id: 10, field: 'updateDate',    headerName: 'תאריך עדכון',  input: 'date', width: 130,                 show: false },
      { id: 11, field: 'inactiveDate',  headerName: 'תאריך הפסקה',  input: 'date', width: 130,                 show: false },
    ]
  },
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    },
  },
})
export const columnsPropertiesAreaGraveSlice = createSlice({
  name: 'columnsAreaGrave',
  initialState: {
    data: [
      { id: 1, field: 'cemeteryNameHe',   headerName: 'בית עלמין', show: true },
      { id: 2, field: 'blockNameHe',      headerName: 'גוש',       show: true },
      { id: 3, field: 'plotNameHe',       headerName: 'חלקה',      show: true },
      { id: 4, field: 'lineNameHe',       headerName: 'שורה',      show: true },
      { id: 5, field: 'areaGraveNameHe',    headerName: 'אחוזת קבר',    show: true },
      { id: 5, field: 'graveType', headerName: 'סוג הקבר', show: true },
      { id: 8, field: 'createDate', headerName: 'תאריך יצירה', show: true },
      { id: 9, field: 'updateDate', headerName: 'תאריך עדכון', show: true },
      { id: 7, field: '', headerName: 'אחוזה קטנה' },
      { id: 10, field: '', headerName: 'כיוון במעלות' },
      { id: 11, field: '', headerName: 'ציר ה - X' },
      { id: 12, field: '', headerName: 'ציר ה - Y' },
    ]
  },
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    },
  },
})
// שדות לטופס קבר
export const columnsFormAreaGraveSlice = createSlice({
  name: 'columnsAreaGrave',
  initialState: {
    data: [

      { name: 'cemeteryId', label: 'בית העלמין',   required: true, width: 250, show: true, input: 'selectedFree', 
        disabled: true
       },
      { name: 'blockId', label: 'גוש',             required: true, width: 250, show: true, input: 'selectedFree', 
        disabled: true
       },
      { name: 'plotId', label: 'חלקה',             required: true, width: 250, show: true, input: 'selectedFree', 
        disabled: true
       },
      { name: 'lineId', label: 'שורה',             required: true, width: 125, show: true, input: 'selectedFree'},
      { name: 'areaGraveNameHe', label: 'מס׳ אחוזת קבר', required: true, width: 125, show: true, input: 'text', notRepeat: true },
      { name: 'graveType', label: 'סוג הקבר',      required: true, width: 100, show: true, input: 'selected'},
      { name: 'coordinates', label: 'קואורדינטות', input: 'text',  width: 300, show: true },
      { id: 10, name: 'comments', label: 'הערות',                  width: 170, show: true, input: 'text' },
      { name: 'addFloor', label: 'הוספת קומה',  required: true, width: 800, show: true, input: 'button', notRepeat: true },
    ]
  },
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    },
  },
})

// Slice for categories of areaGrave
export const categoryAreaGraveSlice = createSlice({
  name: 'categoryAreaGrave',
  initialState: {
    data: [
      { id: 0, setting: { checkbox: true, menu: true } }
    ]
  },
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    },
  },
})

// Exporting actions
export const dataAreaGraveActions = dataAreaGraveSlice.actions
export const columnsTableAreaGraveActions = columnsTableAreaGraveSlice.actions
export const columnsPropertiesAreaGraveActions = columnsPropertiesAreaGraveSlice.actions
export const columnsFormAreaGraveActions = columnsFormAreaGraveSlice.actions
export const categoryAreaGraveActions = categoryAreaGraveSlice.actions
